import React, { forwardRef, type HTMLProps } from 'react';

import { FloatingFocusManager } from '@floating-ui/react';

import { useFloatingContext } from './Floating.context';

type FloatingTransitionProps = HTMLProps<HTMLDivElement> & {
    shouldTrapFocus?: boolean;
};

export const FloatingContent = forwardRef<HTMLDivElement, FloatingTransitionProps>(
    ({ children, style, shouldTrapFocus, ...props }, ref) => {
        const { transitionStyles, context } = useFloatingContext();
        return (
            <FloatingFocusManager
                context={context}
                initialFocus={-1}
                modal={false}
                disabled={!shouldTrapFocus}
            >
                <div
                    style={{
                        ...transitionStyles,
                        ...style
                    }}
                    {...props}
                    ref={ref}
                >
                    {children}
                </div>
            </FloatingFocusManager>
        );
    }
);

FloatingContent.displayName = 'FloatingContent';
